import {
  getReferralDataShare,
  getReferralDataBanner,
  getReferralDataMember,
} from '@/services/referraldata';

const getters = {
  listBanner: state => state.listBanner,
  listShare: state => state.listShare,
  listMember: state => state.listMember,
  per_page: state => state.per_page,
};

const actions = {
  async requestListReferralBanner({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getReferralDataBanner({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_BANNER', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListReferralShare({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getReferralDataShare({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_SHARE', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListReferralMember({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getReferralDataMember({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_MEMBER', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_MEMBER(state, listMember) {
    state.listMember = listMember;
  },
  SET_LIST_BANNER(state, listBanner) {
    state.listBanner = listBanner;
  },
  SET_LIST_SHARE(state, listShare) {
    state.listShare = listShare;
  },
};

export default {
  namespaced: true,
  state: {
    listMember: [],
    listBanner: [],
    listShare: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/ReferralData/index.js